/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ExamClassStudentSelectMulti200,
  GetApiV1ExamClassStudentSelectMulti400,
  GetApiV1ExamClassStudentSelectMulti401,
  GetApiV1ExamClassStudentSelectMulti500,
  GetApiV1ExamClassStudentSelectMultiQueryParams,
  GetApiV1ExamClassStudentSelectMultiQueryResponse,
} from "../../types/examSharedController/GetApiV1ExamClassStudentSelectMulti.ts";
import { dropDownRepositoryResponseSchema } from "../dropDownRepositoryResponseSchema.ts";

export const getApiV1ExamClassStudentSelectMultiQueryParamsSchema = z
  .object({
    filter: z.optional(z.string()),
    companyId: z.optional(z.coerce.number().int()),
    ids: z.optional(z.array(z.coerce.number().int())),
  })
  .optional() as unknown as ToZod<GetApiV1ExamClassStudentSelectMultiQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ExamClassStudentSelectMulti200Schema = z.array(
  z.lazy(() => dropDownRepositoryResponseSchema),
) as unknown as ToZod<GetApiV1ExamClassStudentSelectMulti200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const getApiV1ExamClassStudentSelectMulti400Schema =
  z.any() as unknown as ToZod<GetApiV1ExamClassStudentSelectMulti400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ExamClassStudentSelectMulti401Schema =
  z.any() as unknown as ToZod<GetApiV1ExamClassStudentSelectMulti401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1ExamClassStudentSelectMulti500Schema =
  z.any() as unknown as ToZod<GetApiV1ExamClassStudentSelectMulti500>;

export const getApiV1ExamClassStudentSelectMultiQueryResponseSchema = z.lazy(
  () => getApiV1ExamClassStudentSelectMulti200Schema,
) as unknown as ToZod<GetApiV1ExamClassStudentSelectMultiQueryResponse>;
